/* SPH – m²-Preis (Platten) bzw. Meterpreis (Profile) oben, Streichpreis + Rabatt-Badge, errechneter Stückpreis gross unter der Auswahl */
(function () {
  var root = document.querySelector('[data-sph-product]');
  if (!root) return;
  var h1 = root.querySelector('h1');
  if (h1 && /dachhaut/i.test(h1.textContent || '')) return;
  var priceEl = root.querySelector('[data-sph-price]');
  var idInput = root.querySelector('[data-sph-id]');
  if (!priceEl || !idInput) return;
  var data = [];
  try { data = JSON.parse(root.querySelector('[data-sph-variants]').textContent); } catch (e) { return; }

  function mm(s) { var n = parseInt(String(s || '').replace(/[^0-9]/g, ''), 10); return isNaN(n) ? 0 : n; }

  var fixedWid = 0;
  root.querySelectorAll('[data-sph-panel="tech"] tr').forEach(function (tr) {
    var cells = tr.querySelectorAll('th,td');
    if (cells.length < 2) return;
    var k = (cells[0].textContent || '').toLowerCase();
    if (!fixedWid && (k.indexOf('plattenbreite') > -1 || k.trim() === 'breite')) fixedWid = mm(cells[1].textContent);
  });

  function measure(v) {
    var len = mm(v.options[0]);
    var wid = v.options.length > 1 ? mm(v.options[1]) : 0;
    if (!wid) wid = fixedWid;
    if (len >= 900 && !wid) {
      var m = len / 1000;
      return (m >= 0.9 && m <= 10) ? { m: m, u: 'm' } : null;
    }
    if (len < 100 || wid < 100) return null;
    var m2 = (len / 1000) * (wid / 1000);
    return (m2 > 0.05 && m2 < 25) ? { m: m2, u: 'm\u00b2' } : null;
  }

  function median(a) {
    a.sort(function (x, y) { return x - y; });
    var mid = Math.floor(a.length / 2);
    return a.length % 2 ? a[mid] : (a[mid - 1] + a[mid]) / 2;
  }

  var rates = [], cRates = [], unit = '';
  data.forEach(function (v) {
    var q = measure(v);
    if (q && v.cents) {
      rates.push(v.cents / 100 / q.m);
      unit = q.u;
      if (v.cmp && v.cmp > v.cents) cRates.push(v.cmp / 100 / q.m);
    }
  });
  if (!rates.length) return;
  var rate = median(rates);
  var crate = cRates.length === rates.length ? median(cRates) : 0;
  var pct = crate > rate ? Math.round((1 - rate / crate) * 100) : 0;

  var tag = document.createElement('div');
  tag.className = 'sph-sqm';
  tag.hidden = true;
  priceEl.insertAdjacentElement('beforebegin', tag);

  var opts = root.querySelectorAll('#sph-buy-form .sph-opt');
  var anchor = opts.length ? opts[opts.length - 1] : null;
  var piece = document.createElement('div');
  piece.className = 'sph-piece';
  piece.hidden = true;
  if (anchor) anchor.insertAdjacentElement('afterend', piece);

  function refresh() {
    var id = String(idInput.value || '');
    var v = null;
    for (var i = 0; i < data.length; i++) { if (String(data[i].id) === id) { v = data[i]; break; } }
    var q = v ? measure(v) : null;
    if (!v || !q || !v.cents) {
      tag.hidden = true;
      piece.hidden = true;
      priceEl.classList.remove('sph-price--hidden');
      return;
    }
    var was = pct > 0 ? '<span class="sph-sqm__was"><s>CHF ' + crate.toFixed(2) + '</s><i>\u2212' + pct + ' %</i></span>' : '';
    tag.innerHTML = '<b>CHF ' + rate.toFixed(2) + '<em>/ ' + unit + '</em></b>' + was + '<small style="display:inline;vertical-align:baseline;white-space:nowrap">inkl. MwSt., zzgl. Versand</small>';
    var pWas = (v.cmp && v.cmp > v.cents) ? '<s>CHF ' + (v.cmp / 100).toFixed(2) + '</s>' : '';
    piece.innerHTML = '<span>Ihr St\u00fcckpreis <i>(' + q.m.toFixed(2).replace('.', ',') + ' ' + q.u + ')</i></span><span class="sph-piece__pr">' + pWas + '<b>' + v.price + '</b></span>';
    tag.hidden = false;
    piece.hidden = !anchor;
    priceEl.classList.add('sph-price--hidden');
  }

  root.addEventListener('change', function () { setTimeout(refresh, 0); });
  refresh();
})();
